import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianPostcodeFieldController extends GeneralTreatingPhysicianFieldController {}
